import { all } from 'redux-saga/effects';
import UserNotificationsSagas from 'common/notifications/sagas/UserNotificationsSagas';

export default function* sagas() {
  yield all([
    ...UserNotificationsSagas
  ]);
}
